import { render } from "./fchs.vue?vue&type=template&id=1635d472"
import script from "./fchs.vue?vue&type=script&lang=js"
export * from "./fchs.vue?vue&type=script&lang=js"
script.render = render

export default script